var render = function render(){var _vm=this,_c=_vm._self._c;return _c('applications_datatable',{attrs:{"type":'test',"row-data":_vm.applications,"loading-message":_vm.loadingMessage,"no-rows-message":_vm.noRowsMessage,"columns":_vm.columns,"pagination-size":50}})
}
var staticRenderFns = []

export { render, staticRenderFns }